import SignalRApiService from './SignalRApiService'
import MessageApiService from './MessageApiService'
import CandidateApiService from './CandidateApiService'
import StaffApiService from './StaffApiService'
import MeApiService from './MeApiService'
import ContactApiService from './ContactApiService'
import ClientApiService from './ClientApiService'
import ClientGroupApiService from './ClientGroupApiService'
import FinanceApiService from './FinanceApiService'
import SubBubbleAgreementApiService from './SubBubbleAgreementApiService'
import LocationAlertApiService from './LocationAlertApiService'
import ReleasesApiService from './ReleaseApiService'
import DisputesApiService from './DisputesApiService'

import FormsApiService from './FormsApiService'
import FormTemplatesApiService from './FormTemplatesApiService'
import DevicesApiService from './DevicesApiService'
import CommentsApiService from './CommentsApiService'
import TasksApiService from './TasksApiService'

export default {
  forms: new FormsApiService(),
  formTemplates: new FormTemplatesApiService(),
  finance: new FinanceApiService(),
  contact: new ContactApiService(),
  me: new MeApiService(),
  staff: new StaffApiService(),
  candidate: new CandidateApiService(),
  message: new MessageApiService(),
  signalR: new SignalRApiService(),
  client: new ClientApiService(),
  clientGroup: new ClientGroupApiService(),
  subBubbleAgreement: new SubBubbleAgreementApiService(),
  locationAlert: new LocationAlertApiService(),
  releases: new ReleasesApiService(),
  disputes: new DisputesApiService(),
  devices: new DevicesApiService(),
  comments: new CommentsApiService(),
  tasks: new TasksApiService(),
}
